export const analyticsPt = {
  bookingAnalytics: {
    navigation: {
      analytics: 'Analytics',
    },
    title: 'Analytics de Reservas',
    description: 'Acompanhe o desempenho do seu estúdio e o comportamento das reservas',
    banner: 'As analytics são rastreadas a partir da página pública de reservas. A coleta de dados começa quando os usuários visitam sua página do estúdio.',

    tabs: {
      overview: 'Visão Geral',
      funnel: 'Funil de Reserva',
      performance: 'Desempenho',
      behavior: 'Comportamento do Usuário',
    },

    overview: {
      total_views: 'Visualizações Totais',
      booking_starts: 'Inícios de Reserva',
      completions: 'Conclusões',
      conversion_rate: 'Taxa de Conversão',
      all_time: 'Sempre',
      users_who_started: 'Usuários que iniciaram reserva',
      successful_bookings: 'Reservas bem-sucedidas',
      view_to_booking: 'Vista para reserva',
    },

    funnel: {
      title: 'Análise do Funil de Reserva',
      description: 'Acompanhe como os usuários progridem através do processo de reserva',
      studio_views: 'Visualizações da Página do Estúdio',
      booking_starts: 'Reserva Iniciada',
      room_selections: 'Sala Selecionada',
      date_selections: 'Data/Hora Selecionada',
      completions: 'Reserva Concluída',
    },

    performance: {
      coming_soon: 'Métricas de desempenho detalhadas em breve. Acompanhe salas populares, horários e padrões de reserva.',
    },

    behavior: {
      coming_soon: 'Analytics de comportamento do usuário em breve. Compreenda o uso de dispositivos, padrões de engajamento e interações do usuário.',
    },

    coming_soon: {
      title: 'Analytics Detalhadas em Breve',
      description: 'Estamos atualmente coletando dados analíticos da sua página de reserva. Assim que dados suficientes forem coletados, você verá gráficos detalhados, diagramas e insights sobre o desempenho do seu estúdio, horários de reserva populares, preferências de salas e métricas de conversão.',
    },

    sharing: {
      title: 'Analytics de Compartilhamento',
      description: 'Acompanhe como seu estúdio está sendo compartilhado e meça o sucesso de referências',
      no_data: 'Ainda não há dados de compartilhamento. Compartilhe seu estúdio para começar a rastrear!',

      overview: {
        total_shares: 'Compartilhamentos Totais',
        total_clicks: 'Cliques em Links',
        total_bookings: 'Reservas de Compartilhamentos',
        total_revenue: 'Receita de Compartilhamentos',
        conversion_rate: 'Taxa de Conversão de Compartilhamento',
        click_to_view: 'Taxa de Clique para Visualização',
        view_to_booking: 'Taxa de Visualização para Reserva',
      },

      funnel: {
        title: 'Funil de Conversão de Compartilhamento',
        description: 'Acompanhe como os links compartilhados se convertem em reservas',
        clicks: 'Cliques em Links',
        views: 'Visualizações do Estúdio',
        booking_starts: 'Reserva Iniciada',
        completions: 'Reservas Concluídas',
      },

      methods: {
        title: 'Desempenho do Método de Compartilhamento',
        description: 'Veja quais plataformas geram mais reservas',
      },

      leaderboard: {
        title: 'Melhores Compartilhadores',
        description: 'Usuários que geraram mais receita através do compartilhamento',
        rank: 'Posição',
        name: 'Nome',
        shares: 'Compartilhamentos',
        bookings: 'Reservas',
        revenue: 'Receita',
        rewards: 'Recompensas',
      },
    },
  },
};
